import { render, staticRenderFns } from "./DLGEventItems.vue?vue&type=template&id=19809165&scoped=true&"
import script from "./DLGEventItems.vue?vue&type=script&lang=js&"
export * from "./DLGEventItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19809165",
  null
  
)

export default component.exports